<template>
    <v-card min-height="500px" class="ma-auto">
        <v-col sm="12" md="12" lg="12" class="ma-auto grey lighten-5">
            <v-img
                v-if="usuarioPartner"
                class="ma-auto"
                align-center
                justify-center
                :src="logoBvs"
                width="20vw"
                alt="logo-recuperi"
            />
            <v-img
                v-if="!usuarioPartner"
                class="ma-auto"
                align-center
                justify-center
                :src="logo"
                width="12vw"
                alt="logo-recuperi"
            />
        </v-col>
        <v-col sm="12" md="8" lg="8" class="ma-auto">
            <p class="text-justify font-weight-black mt-8">
                Olá {{ nomeDevedor }},
            </p>
            <p class="text-justify mt-8">
                Obrigado pela negociação/pagamento com
                {{ nomeExibicaoApresentante }} referente ao título
                {{ ds_nosso_numero }}, que se encontra em procedimento de
                protesto.
            </p>
            <p class="text-justify">
                Caso você seja intimado pelo cartório sobre o protesto desta
                dívida, fique tranquilo(a)! {{ nomeExibicaoApresentante }} já
                programou o envio da anuência eletrônica do título
                {{ ds_nosso_numero }}.
            </p>
            <p class="text-justify">
                Isso significa que a anuência eletrônica será enviada e
                processada assim que o procedimento de protesto for finalizado
                pelo cartório, o que pode levar alguns dias.
            </p>

            <p class="text-justify mt-6">
                Assim que este procedimento for finalizado, você receberá um
                novo e-mail com orientações e o contato do cartório para então
                (i) informar ao cartório que você negociou/pagou sua dívida com
                {{ nomeExibicaoApresentante }}, (ii) pagar as custas/emolumentos
                do cartório e (iii) solicitar a retirada do protesto do seu
                nome.
            </p>

            <v-col class="ma-auto text-center">
                O valor das custas/emolumentos será informado pelo próprio
                cartório. Qualquer dúvida, entre em contato com
                {{ nomeExibicaoApresentante }}.
            </v-col>
        </v-col>

        <v-col sm="12" md="12" lg="12" class="ma-auto text-center">
            Atenciosamente, equipe Recuperi
        </v-col>
        <v-col sm="12" md="12" lg="12" class="text-center grey lighten-5">
            <p class="font-weight-light subtitle-2">
                Observação: Essa é uma prévia do e-mail enviado, utilizamos esse
                modelo para envio a todos os devedores
            </p>
            <v-btn
                small
                color="grey lighten-3"
                class="ma-auto"
                @click="fecharModal"
            >
                Fechar
            </v-btn>
        </v-col>
    </v-card>
</template>

<script>
export default {
    name: 'Template250',
    props: {
        usuarioPartner: {
            type: Boolean,
            default: false,
            required: true
        },
        nomeDevedor: {
            type: String,
            default: ''
        },
        nomeExibicaoApresentante: {
            type: String,
            default: ''
        },
        ds_nosso_numero: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            logo: require('@/assets/logo_recuperi_azul_escura.png'),
            logoBvs: require('@/assets/recuperi-boavista-email-original.png')
        };
    },
    methods: {
        fecharModal() {
            this.$emit('fecharModal', false);
        }
    }
};
</script>

<style></style>
